import { render, staticRenderFns } from "./CriterioSelectUserTags.vue?vue&type=template&id=4a2d9400"
import script from "./CriterioSelectUserTags.vue?vue&type=script&lang=js"
export * from "./CriterioSelectUserTags.vue?vue&type=script&lang=js"
import style0 from "./CriterioSelectUserTags.vue?vue&type=style&index=0&id=4a2d9400&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports